import { PAGES } from 'hb-react/shared/hooks/usePageMenuNames';

export const ENTITY_TYPES = {
  adminEvent: 'admin_event',
  company: 'company',
  customPage: 'custom_page',
  forumDiscussion: 'forum_discussion',
  group: 'group',
  mediaCenterFile: 'media_center_file',
  mediaCenterFolder: 'media_center_folder',
  news: 'news',
  opportunity: 'opportunity',
  portfolioFile: 'portfolio_file',
  portfolioFolder: 'portfolio_folder',
  post: 'post',
  project: 'project',
  user: 'user',
  userEvent: 'user_event',
} as const;

export const LEGACY_ENTITY_TYPES = {
  adminEvent: 'network_event',
  opportunity: 'business_opportunity',
  post: 'feed_post',
} as const;

export const ENTITY_PAGE_MAP = {
  [ENTITY_TYPES.adminEvent]: PAGES.EVENTS,
  [ENTITY_TYPES.company]: PAGES.COMPANIES,
  [ENTITY_TYPES.customPage]: undefined,
  [ENTITY_TYPES.forumDiscussion]: PAGES.FORUM,
  [ENTITY_TYPES.group]: PAGES.TOPICS,
  [ENTITY_TYPES.mediaCenterFile]: PAGES.MEDIA_CENTER,
  [ENTITY_TYPES.mediaCenterFolder]: PAGES.MEDIA_CENTER,
  [ENTITY_TYPES.news]: PAGES.NEWS,
  [ENTITY_TYPES.opportunity]: PAGES.BUSINESS_OPPORTUNITIES,
  [ENTITY_TYPES.portfolioFile]: PAGES.PORTFOLIOS,
  [ENTITY_TYPES.portfolioFolder]: PAGES.PORTFOLIOS,
  [ENTITY_TYPES.post]: undefined,
  [ENTITY_TYPES.project]: PAGES.VENTURES,
  [ENTITY_TYPES.user]: undefined,
  [ENTITY_TYPES.userEvent]: PAGES.EVENTS,
  // Legacy types
  [LEGACY_ENTITY_TYPES.adminEvent]: PAGES.EVENTS,
  [LEGACY_ENTITY_TYPES.opportunity]: PAGES.BUSINESS_OPPORTUNITIES,
  [LEGACY_ENTITY_TYPES.post]: undefined,
} as const;
